import { useId } from 'react';

const CHART_SKELETON_WIDTH = 900;
const CHART_SKELETON_HEIGHT = 268;
const CHART_SKELETON_LINE_POINTS =
    '0,200 130,180 260,220 390,150 520,190 650,120 780,170 900,140';

export interface ChartSkeletonProps {
    height?: number;
}

export function ChartSkeleton({ height = 298 }: ChartSkeletonProps) {
    const reactId = useId();
    const gradientId = `chart-line-shimmer-${reactId}`;

    return (
        <div className="relative" style={{ height }}>
            <svg
                className="w-full h-full"
                viewBox={`0 0 ${CHART_SKELETON_WIDTH} ${CHART_SKELETON_HEIGHT}`}
                preserveAspectRatio="none"
            >
                <defs>
                    <linearGradient
                        id={gradientId}
                        gradientUnits="userSpaceOnUse"
                        x1="0"
                        y1="0"
                        x2={CHART_SKELETON_WIDTH}
                        y2="0"
                    >
                        <stop offset="0%" stopColor="var(--grey-550)" />
                        <stop offset="45%" stopColor="var(--grey-550)" />
                        <stop offset="50%" stopColor="var(--grey-500)" />
                        <stop offset="55%" stopColor="var(--grey-550)" />
                        <stop offset="100%" stopColor="var(--grey-550)" />
                        <animateTransform
                            attributeName="gradientTransform"
                            type="translate"
                            from={`${-CHART_SKELETON_WIDTH} 0`}
                            to={`${CHART_SKELETON_WIDTH} 0`}
                            dur="2s"
                            repeatCount="indefinite"
                        />
                    </linearGradient>
                </defs>
                {[10, 62, 114, 166, 218].map((y) => (
                    <line
                        key={y}
                        x1="0"
                        y1={y}
                        x2={CHART_SKELETON_WIDTH}
                        y2={y}
                        stroke="var(--grey-600)"
                        strokeWidth="1"
                        strokeDasharray="3 3"
                    />
                ))}
                <polyline
                    points={CHART_SKELETON_LINE_POINTS}
                    fill="none"
                    stroke="var(--grey-600)"
                    strokeWidth="3"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                />
                <polyline
                    points={CHART_SKELETON_LINE_POINTS}
                    fill="none"
                    stroke={`url(#${gradientId})`}
                    strokeWidth="3"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                />
            </svg>
            <div className="absolute bottom-0 left-0 right-0 flex justify-between px-2">
                {[1, 2, 3, 4, 5, 6, 7].map((i) => (
                    <div key={i} className="h-3 w-10 skeleton-item rounded" />
                ))}
            </div>
        </div>
    );
}
